//
// BackupMenu
//
// Actions for the global backup menu

import { observer } from 'mobx-react-lite'
import { useStore } from '../stores'

import { VView } from '../appview'
import { Icon, Menu, MenuItem, Text } from '../components'

export const BackupMenu = observer(function BackupMenu({ dismiss }) {
    const store = useStore()
    const { app, data, MAX_BACKUPS } = store

    const onGotoBackups = () => {
        store.view.savePerProject('/settings/navigatorItem', 'backups')
        store.view.setWorkspace('settings')
        dismiss && dismiss()
    }

    const max_backups_reached =
        store.project.backups.get('versions').length >= MAX_BACKUPS
    const panel_width = max_backups_reached ? 200 : 160

    return (
        <VView className="actions-panel" style={{ width: panel_width }}>
            {max_backups_reached ? (
                <Text className="cc-danger">
                    {app.text(
                        'Maximum number of backups used, please delete a few before creating a new one.'
                    )}
                </Text>
            ) : undefined}
            <Menu>
                <MenuItem
                    disabled={max_backups_reached}
                    onClick={() => {
                        dismiss && dismiss()
                        data.actions.backups.createBackup(store.user.name)
                    }}
                >
                    {app.text('Create a new backup')}
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        dismiss && dismiss()
                        onGotoBackups()
                    }}
                >
                    <Icon size="text" name="navigate" /> {app.text('Go to Backups')}
                </MenuItem>
            </Menu>
        </VView>
    )
})
